export default {
    name: 'DeactiveAsset',
  };